/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import './search_products';
import '../../common/locale';
import '../../resources/product';
import '../../../../connect/v2/resources/error';

const $root = ($protobuf.roots['default']|| ($protobuf.roots['default'] = new $protobuf.Root()));

$root.addJSON({
  "squareup": {
    "nested": {
      "solidshop": {
        "nested": {
          "v2": {
            "nested": {
              "service": {
                "nested": {
                  "SearchInternalProductsRequest": {
                    "fields": {
                      "query": {
                        "type": "squareup.solidshop.v2.service.SearchProductsQuery",
                        "id": 1,
                        "rule": "optional"
                      },
                      "limit": {
                        "type": "int32",
                        "id": 2,
                        "rule": "optional",
                        "options": {
                          "default": 100
                        }
                      },
                      "cursor": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "locale": {
                        "type": "squareup.solidshop.v2.common.Locale",
                        "id": 4,
                        "rule": "optional",
                        "options": {
                          "default": "EN_US"
                        }
                      }
                    }
                  },
                  "SearchInternalProductsResponse": {
                    "fields": {
                      "products": {
                        "type": "squareup.solidshop.v2.resources.Product",
                        "id": 1,
                        "rule": "repeated"
                      },
                      "errors": {
                        "type": "squareup.connect.v2.resources.Error",
                        "id": 2,
                        "rule": "repeated"
                      },
                      "cursor": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
});

/**
 * SOURCE SearchInternalProductsRequest @ squareup/solidshop/v2/service/products/search_internal_products.proto at 13:1
 */
export const SearchInternalProductsRequest = $root.lookupType('squareup.solidshop.v2.service.SearchInternalProductsRequest');
fixType(SearchInternalProductsRequest);
Builder.createAndAttachToType(SearchInternalProductsRequest);
/**
 * SOURCE SearchInternalProductsResponse @ squareup/solidshop/v2/service/products/search_internal_products.proto at 27:1
 */
export const SearchInternalProductsResponse = $root.lookupType('squareup.solidshop.v2.service.SearchInternalProductsResponse');
fixType(SearchInternalProductsResponse);
Builder.createAndAttachToType(SearchInternalProductsResponse);
